import Image from 'next/image'
import { IArticle } from '../../../../services/hrInsider'
import { CardArticleCss } from './index.css'
interface IProps {
	post?: IArticle
}
const UTM_STRING =
	'?utm_source=websiteVNWs&utm_medium=traffic&utm_campaign=CP2023'
export default function CardArticle({ post }: IProps) {
	return (
		<CardArticleCss
			href={`https://vietnamworks.com${post?.url ?? ''}${
				post?.url ? UTM_STRING : ''
			}`}
			target='_blank'
			className='section__article-item'
		>
			<div className='thumb'>
				<div className='thumb__image'>
					<img src={
						post?.image ?? ''
					} className='avatar__iamge' width={516}
						 height={284} alt={'avatar'} />

				</div>
			</div>
			<div className='info'>
				<p className='info__title'>{post?.title ?? ''}</p>
				<p className='info__description'>{post?.description}</p>
				<p className='info__created-at'>{post?.date ?? ''}</p>
			</div>
		</CardArticleCss>
	)
}
